module.exports = __webpack_public_path__ + "assets/img/xlwy_3.5112c588.png";